// extracted by mini-css-extract-plugin
export default {"navigationLink":"PrescriptionRenewalsViewNavigationBar_navigationLink__HHqY5","active":"PrescriptionRenewalsViewNavigationBar_active__cZCp5"};